import { BaseModel } from './base-model';

export class AppointmentTypeModel extends BaseModel {
    name: string = ""

    constructor(params: any = null) {
        super(params)
        this.copyFromObject(params)
    }

    static override newModel(params: any = null): AppointmentTypeModel {
        return new AppointmentTypeModel(params)
    }
}
